module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang) ? _c('div', {
    staticClass: "Office"
  }, [_c('md-whiteframe', {
    staticClass: "shadow shadow-faint"
  }, [_c('div', {
    staticClass: "search search--field"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('md-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.query),
      expression: "search.query"
    }],
    staticStyle: {
      "outline": "0"
    },
    attrs: {
      "type": "text",
      "placeholder": "Buscar consultas"
    },
    domProps: {
      "value": (_vm.search.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.searchIndicator))])]), _vm._v(" "), (_vm.addButton) ? _c('md-button', {
    staticClass: "md-icon-button md-raised button",
    nativeOn: {
      "click": function($event) {
        _vm.addExtraHours($event)
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1) : _c('md-button', {
    staticClass: "md-icon-button md-raised button-remove",
    nativeOn: {
      "click": function($event) {
        _vm.removeExtraHours($event)
      }
    }
  }, [_c('md-icon', [_vm._v("clear")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table table-mobile table--office table--abs"
  }, [(_vm.extraHours.length > 0) ? _c('md-table-card', {
    staticClass: "table--wrap"
  }, [_c('md-table', {
    attrs: {
      "md-sort": "name",
      "md-sort-by": "name"
    },
    on: {
      "sort": _vm.onSort,
      "select": _vm.onSelect
    }
  }, [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', {
    staticClass: "td-sort-name",
    attrs: {
      "md-sort-by": "name"
    }
  }, [_vm._v(" " + _vm._s(_vm.translate.pages.extrahours.index.fields.office))]), _vm._v(" "), _c('md-table-head', {
    staticClass: "hidden-mobile",
    attrs: {
      "md-sort-by": "start"
    }
  }, [_vm._v(" " + _vm._s(_vm.translate.pages.extrahours.index.fields.start) + " ")]), _vm._v(" "), _c('md-table-head', {
    staticClass: "hidden-mobile",
    attrs: {
      "md-sort-by": "end"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.extrahours.index.fields.end))]), _vm._v(" "), _c('md-table-head', {
    staticClass: "hidden-mobile",
    attrs: {
      "md-sort-by": "reason"
    }
  }, [_vm._v("Motivo")]), _vm._v(" "), _c('md-table-head', {
    staticClass: "text-center hidden-mobile"
  }, [_vm._v(_vm._s(_vm.translate.pages.extrahours.index.fields.actions))])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.extraHours), function(row, rowIndex) {
    return _c('md-table-row', {
      key: rowIndex,
      attrs: {
        "md-item": row,
        "md-selection": ""
      }
    }, [_c('md-table-cell', [_c('img', {
      staticClass: "img",
      attrs: {
        "src": _vm.srcImage(row.office.path),
        "height": "40",
        "width": "40"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(row.office.name))])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "double-content"
    }, [_c('span', {
      staticClass: "first-content"
    }, [_vm._v(_vm._s(_vm._f("formatTimeStamp")(row.start)))]), _vm._v(" "), _c('span', {
      staticClass: "last-content visible-lsmall"
    }, [_vm._v(_vm._s(_vm._f("formatTimeStamp")(row.end)))])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "hidden-lsmall"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatTimeStamp")(row.end)))])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "hidden-mobile"
    }, [_c('span', [_vm._v(_vm._s(row.reason))])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "actions"
    }, [_c('md-icon', {
      staticClass: "icon-edit raised",
      nativeOn: {
        "click": function($event) {
          _vm.openDialog('edit', row, rowIndex)
        }
      }
    }, [_vm._v("edit")]), _vm._v(" "), _c('md-icon', {
      staticClass: "icon-delete raised",
      nativeOn: {
        "click": function($event) {
          _vm.remove(row, rowIndex)
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  }))], 1), _vm._v(" "), _c('md-dialog', {
    ref: "edit",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom",
      "md-click-outside-to-close": _vm.close,
      "md-esc-to-close": _vm.close
    }
  }, [_c('md-dialog-content', [_c('h3', {
    staticClass: "dialog--title"
  }, [_vm._v(_vm._s(_vm.translate.pages.extrahours.index.edit.title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content-main"
  }, [_c('md-layout', {
    staticClass: "modal-wrap",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.office.invalid
    },
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.extrahours.index.edit.fields.consult))]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "office",
      "id": "office"
    },
    model: {
      value: (_vm.currentExtraHours.office),
      callback: function($$v) {
        _vm.currentExtraHours.office = $$v
      },
      expression: "currentExtraHours.office"
    }
  }, _vm._l((_vm.offices), function(office) {
    return _c('md-option', {
      key: office.id,
      attrs: {
        "value": office.id
      }
    }, [_vm._v(_vm._s(office.name))])
  })), _vm._v(" "), (_vm.errors.office.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.office.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "amolpicker container-date",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.extrahours.index.edit.fields.start_date))]), _vm._v(" "), _c('md-icon', {
    staticClass: "icon-calendar"
  }, [_vm._v("today")]), _vm._v(" "), _c('date-picker', {
    staticClass: "picker",
    attrs: {
      "option": _vm.option,
      "limit": _vm.limit,
      "date": _vm.startDate
    },
    model: {
      value: (_vm.currentExtraHours.start_date),
      callback: function($$v) {
        _vm.currentExtraHours.start_date = $$v
      },
      expression: "currentExtraHours.start_date"
    }
  }), _vm._v(" "), (_vm.errors.start_date.invalid) ? _c('small', {
    staticClass: "small-error"
  }, [_vm._v(_vm._s(_vm.errors.start_date.msg))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "amoltimer",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.extrahours.index.edit.fields.start_time))]), _vm._v(" "), _c('md-icon', [_vm._v("query_builder")]), _vm._v(" "), _c('vue-timepicker', {
    staticClass: "timer",
    attrs: {
      "format": "HH:mm"
    },
    on: {
      "change": function($event) {
        _vm.updateTime($event, 'start_time')
      }
    },
    model: {
      value: (_vm.currentExtraHours.start_time_value),
      callback: function($$v) {
        _vm.currentExtraHours.start_time_value = $$v
      },
      expression: "currentExtraHours.start_time_value"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-error"
  }, [_vm._v(_vm._s(_vm.errors.start_time.msg))])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "amolpicker container-date",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.extrahours.index.edit.fields.end_date))]), _vm._v(" "), _c('md-icon', {
    staticClass: "icon-calendar"
  }, [_vm._v("today")]), _vm._v(" "), _c('date-picker', {
    staticClass: "picker",
    attrs: {
      "option": _vm.option,
      "limit": _vm.limit,
      "date": _vm.endDate
    },
    model: {
      value: (_vm.currentExtraHours.end_date),
      callback: function($$v) {
        _vm.currentExtraHours.end_date = $$v
      },
      expression: "currentExtraHours.end_date"
    }
  }), _vm._v(" "), (_vm.errors.end_date.invalid) ? _c('small', {
    staticClass: "small-error"
  }, [_vm._v(_vm._s(_vm.errors.end_date.msg))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "amoltimer",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.extrahours.index.edit.fields.end_time))]), _vm._v(" "), _c('md-icon', [_vm._v("query_builder")]), _vm._v(" "), _c('vue-timepicker', {
    staticClass: "timer",
    attrs: {
      "format": "HH:mm"
    },
    on: {
      "change": function($event) {
        _vm.updateTime($event, 'end_time')
      }
    },
    model: {
      value: (_vm.currentExtraHours.end_time_value),
      callback: function($$v) {
        _vm.currentExtraHours.end_time_value = $$v
      },
      expression: "currentExtraHours.end_time_value"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-error"
  }, [_vm._v(_vm._s(_vm.errors.end_time.msg))])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-checkbox', {
    staticClass: "md-primary checkbox-list",
    attrs: {
      "md-theme": "green",
      "id": "interval",
      "name": "interval"
    },
    model: {
      value: (_vm.currentExtraHours.interval),
      callback: function($$v) {
        _vm.currentExtraHours.interval = $$v
      },
      expression: "currentExtraHours.interval"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.translate.pages.extrahours.index.edit.checkbox.strong))]), _vm._v(" "), _c('span', {
    staticClass: "color_form_placeholder normal"
  }, [_vm._v("    " + _vm._s(_vm.translate.pages.extrahours.index.edit.checkbox.span))])])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.reason.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.extrahours.index.edit.reason))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.currentExtraHours.reason),
      callback: function($$v) {
        _vm.currentExtraHours.reason = $$v
      },
      expression: "currentExtraHours.reason"
    }
  }), _vm._v(" "), (_vm.errors.reason.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.reason.msg))]) : _vm._e()], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', {
    staticClass: "modal--footer"
  }, [_c('md-button', {
    staticClass: "float-l md-primary sm-size md-size",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('edit')
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.extrahours.index.edit.cancel))]), _vm._v(" "), _c('md-button', {
    staticClass: "float-r md-primary sm-size md-size btn--blue",
    attrs: {
      "disabled": _vm.process
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('edit', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.extrahours.index.edit.save))])], 1)], 1)], 1) : _c('div', [(_vm.search.isQuery) ? _c('h3', {
    staticClass: "not-found mini-found"
  }, [_vm._v(_vm._s(_vm.translate.pages.extrahours.index.no_result) + " \""), _c('strong', [_vm._v(_vm._s(_vm.search.query) + "\".")])]) : _c('h3', [(_vm.fetchData) ? _c('span', {
    staticClass: "not-found mini-found"
  }, [_vm._v(_vm._s(_vm.translate.pages.extrahours.index.no_records))]) : _c('span', [_c('div', {
    staticClass: "sk-rotating-plane"
  })])])])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ee65f69"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/ExtraHours/Index.vue
// module id = 686
// module chunks = 1